(function() {

    angular
      .module('meanApp')
      .service('currentUser', currentUser);
  
      currentUser.$inject = [
            '$rootScope', 
            'authentication', 
            //'usersManager',
            '$q',
            '$injector'];
      function currentUser (
            $rootScope, 
            authentication, 
            //usersManager,
            $q,
            $injector)
            {
        
        this._currentUser = null;
        this._isBeingFetched = false;
        this._promise = null;

        //tobe used just right after registration or login
        this.set = function(currentUser) {
            this._currentUser = currentUser;
        };

        //this init the singleton user
        this.get = function() {
            var deferred = $q.defer();
            
            if(this._currentUser) {
                console.log('user service already fetched');
                deferred.resolve(this._currentUser);
            }
            else if(!this._isBeingFetched){
                console.log('user service will be fetched');
                this._isBeingFetched = true;
                this._promise = $q.defer();
                var idCurrentUser = authentication.getCurrentUserId();

                if (idCurrentUser) {
                    //dynamic dependency to avoid circular dependency
                    var usersManager= $injector.get('usersManager');
                    usersManager.get(idCurrentUser).then(function(result) {
                        this._currentUser = result;
                        this._isBeingFetched = false;
                        this._promise.resolve(this._currentUser);
                        deferred.resolve(this._currentUser);
                        
                    }.bind(this), function(err) {
                        /**this._promise.reject(err);
                        deferred.reject(err);**/
                        this._promise.reject(null);
                        deferred.reject(null);
                    }.bind(this));
                }
                else {
                    this._currentUser = {};
                    this._promise.resolve(this._currentUser);
                    deferred.resolve(this._currentUser);
                }
            }
            else {
                //wait for the result and give it
                //here do a deffered resolve
                console.log('user service pending');
                this._promise.promise.then(function(currentUser) {
                    console.log('will be deffered after the being fetched');
                    deferred.resolve(currentUser);
                }, function(err) {
                    deferred.resolve(null);
                    //deferred.reject(err);
                    //resolve it anyway but with null inside

                });
            }
            
            return deferred.promise;
        };
  
        return this;
      }
  
  })();